module.exports = __webpack_public_path__ + "img/60036.e1df5b98.png";